import Styled from 'styled-components'

export const CollapsibleContainer = Styled.article<{ large?: boolean }>`
  width: 100%;
  height: auto;
  margin-bottom: ${({ large }) => (large ? '2.4rem' : '0.8rem')};
`
export const CollapsibleHeader = Styled.header<{ primaryColor: string; large?: boolean; show: boolean }>`
    width: 100%;
    height: ${({ large }) => (large ? `5.4rem` : '4rem')};
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #dde0e5;
    border-radius: ${({ show, large }) => {
      const hidenRadius = large ? '0.8rem' : '0.6rem'
      const showRadius = large ? '0.8rem 0.8rem 0 0' : '0.6rem 0.6rem 0 0'
      return show ? showRadius : hidenRadius
    }};
    padding: 8px 16px 8px 16px;
    background: ${({ large }) => (large ? '#ffffff' : '#f3f5f9')};

    @media (max-width: 730px) {
      height: auto;
      flex-direction: ${({ large }) => (large ? 'row' : 'column')};
    }
    & > p {
      font-size: ${({ large }) => (large ? '2rem' : '1.6rem')};
      font-style: normal;
      font-weight: ${({ large }) => (large ? '500' : 'normal')};
      line-height: ${({ large }) => (large ? '2.8rem' : '2.5rem')};
      margin: 0;
      color: black;
    }
    & > div {
      width: 40rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: rgba(0, 0, 0, 0.45);
      @media (max-width: 730px) {
      justify-content: ${({ large }) => (large ? 'flex-end' : 'center')};
    }
      & > span:first-child {
        width: 1.4rem;
        height: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 1rem;
        & > svg {
          width: 14px;
          height: 15px;
        }
      }
      & > .icon {
        width: 11px;
        height: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        & > svg {
          width: 11px;
          height: 12px;
        }
      }
      & > p {
        margin: 0 18px 0 0;
      }
      & > .available-slots{
        color: black;
        font-weight: bold;
      }
      & > span:last-child {
        color: ${({ primaryColor }) => primaryColor};
        width: ${({ large }) => (large ? '2rem' : '1.4rem')};
        height: ${({ large }) => (large ? '2rem' : '1.5rem')};
        & > svg{
          font-size: ${({ large }) => (large ? '2rem' : '1.4rem')};
          width: ${({ large }) => (large ? '2rem' : '1.4rem')};
          height: ${({ large }) => (large ? '2rem' : '1.5rem')};
        }
      }
  }
`
export const CollapsibleBody = Styled.section<{ show: boolean }>`
  width: 100%;
  height: ${({ show }) => (show ? 'auto' : '0')};
  display: flex;
  justify-content: flex-start;
  border-left: ${({ show }) => (show ? '1px solid #dde0e5' : 'none')};
  border-right: ${({ show }) => (show ? '1px solid #dde0e5' : 'none')};
  border-bottom: ${({ show }) => (show ? '1px solid #dde0e5' : 'none')};
  transition: height 0.5s linear, border-bottom 0.5s linear, border-left 0.5s linear, border-right 0.5s linear;
  @media (max-width:768px){
    flex-direction: column;
  }
`
